import BillingSummaryCSVPreviewColumnsStrategy from './BillingSummaryCSVPreviewColumnsStrategy'

export default function BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy() {}
BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype = new BillingSummaryCSVPreviewColumnsStrategy();
BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.init = function ( showAverageRates )
{
    BillingSummaryCSVPreviewColumnsStrategy.prototype.init.call( this );
    this.showAverageRates = showAverageRates;
    return this;
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.getNumOfDataColumns = function ()
{
    return this.showAverageRates ? 5 : 4;
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.only_billible.csv") );
    if ( this.showAverageRates )
        this.addCell( mainHeaderRow, this.message("report.billing_summary.average_rate.csv", [SystemSettings.currencySign]) );
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_amount.csv", [SystemSettings.currencySign]) );
    this.addCell( mainHeaderRow, this.message("report.billing_summary.spent") );
    this.addCell( mainHeaderRow, this.message("report.billing_summary.amount") );
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    var numOfEmptyCells = this.showAverageRates ? 3 : 2;
    ReportPreviewUtils.addEmptyCells( colGroupingRow, numOfEmptyCells );
    this.addBillingTypeCells( colGroupingRow, this.getNumOfDataColumns() - numOfEmptyCells );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.js